import { render, staticRenderFns } from "./schedule-class-form.vue?vue&type=template&id=4e68b36d&scoped=true"
import script from "./schedule-class-form.vue?vue&type=script&lang=js"
export * from "./schedule-class-form.vue?vue&type=script&lang=js"
import style0 from "./schedule-class-form.vue?vue&type=style&index=0&id=4e68b36d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e68b36d",
  null
  
)

export default component.exports